import { type SectionConfig } from '@/utils/get-matched-section'

export const sectionConfig: SectionConfig = {
  '/deployments/dashboard': {
    title: 'Deployments Dashboard',
    showBreadcrumbs: false
  },
  '/deployments/projects': {
    title: 'Projects'
  },
  '/deployments/work-orders': {
    title: 'Work Orders'
  },
  '/deployments/change-orders': {
    title: 'Change Orders'
  },
  '/deployments/change-orders/settings': {
    title: 'Change Order Settings',
    parentBreadcrumb: {
      label: 'Change Orders',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/change-orders`
    }
  },
  '/deployments/change-orders/[number]': {
    title: (params) => (params as { number?: string }).number ?? 'Change order',
    parentBreadcrumb: {
      label: 'Change Orders',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/change-orders`
    }
  },
  '/deployments/change-orders/[number]/edit': {
    title: 'Edit initial questions',
    parentBreadcrumb: [
      {
        label: 'Change Orders',
        href: (_params, orgSlug) => `/${orgSlug}/deployments/change-orders`
      },
      {
        label: (params) =>
          (params as { number?: string }).number ?? 'Change order',
        href: (params, orgSlug) =>
          `/${orgSlug}/deployments/change-orders/${(params as { number?: string }).number ?? ''}`
      }
    ]
  },
  '/deployments/milestones': {
    // Full-bleed so the List tab's table fills the height left under the tab
    // row; the region-height cap alone overflows by the tab row.
    fullBleed: true,
    title: 'Milestones'
  },
  '/deployments/invoices': {
    title: 'Invoices'
  },
  '/deployments/invoices/[invoiceId]': {
    title: (params) => {
      const p = params as { invoiceId?: string }
      return p?.invoiceId ? `${p.invoiceId}` : 'Invoice'
    },
    parentBreadcrumb: {
      label: 'Invoices',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/invoices`
    }
  },
  // Static: this param is a record id, not a readable number, and the page title
  // has no runtime override — the record header carries the number.
  '/deployments/invoices/native/[invoiceId]': {
    title: 'Invoice',
    parentBreadcrumb: {
      label: 'Invoices',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/invoices`
    }
  },
  '/deployments/tools': {
    title: 'Tools'
  },
  '/deployments/tools/mikrotik': {
    title: 'MikroTik Router',
    parentBreadcrumb: {
      label: 'Tools',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/tools`
    }
  },
  '/deployments/tools/cisco-2960x': {
    title: 'Cisco 2960X',
    parentBreadcrumb: {
      label: 'Tools',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/tools`
    }
  },
  '/deployments/tools/cmts': {
    title: 'CMTS',
    parentBreadcrumb: {
      label: 'Tools',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/tools`
    }
  },
  '/deployments/tools/pfsense': {
    title: 'pfSense',
    parentBreadcrumb: {
      label: 'Tools',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/tools`
    }
  },
  '/deployments/tools/tlx-guide': {
    title: 'TLX Configuration Guide',
    parentBreadcrumb: {
      label: 'Tools',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/tools`
    }
  },
  '/deployments/tools/pm-checklist': {
    title: 'PM Pre-Check List',
    parentBreadcrumb: {
      label: 'Tools',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/tools`
    }
  },
  '/deployments/tools/pm-checklist/manage': {
    title: 'Manage lists',
    parentBreadcrumb: {
      label: 'PM Pre-Check List',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/tools/pm-checklist`
    }
  },
  '/deployments/tools/activations-workbook': {
    title: 'FTG / OTT Activations Workbook',
    parentBreadcrumb: {
      label: 'Tools',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/tools`
    }
  },
  '/deployments/tools/network-request': {
    title: 'Network Request (LSP)',
    parentBreadcrumb: {
      label: 'Tools',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/tools`
    }
  },
  '/deployments/tools/network-request/manage': {
    title: 'Manage templates',
    parentBreadcrumb: {
      label: 'Network Request (LSP)',
      href: (_params, orgSlug) =>
        `/${orgSlug}/deployments/tools/network-request`
    }
  },
  '/deployments/tools/topology': {
    title: 'Topology Generator',
    parentBreadcrumb: {
      label: 'Tools',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/tools`
    }
  },
  '/deployments/tools/positron': {
    title: 'Positron GAM Provisioning',
    parentBreadcrumb: {
      label: 'Tools',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/tools`
    }
  },
  '/deployments/projects/[projectId]': {
    fullBleed: true,
    title: (params) => {
      const p = params as { projectId?: string }
      return p?.projectId ? `${p.projectId}` : 'Project'
    },
    parentBreadcrumb: {
      label: 'Projects',
      href: (_params, orgSlug) => `/${orgSlug}/deployments/projects`
    }
  },
  '/deployments/projects/[projectId]/change-orders/new': {
    title: 'New change order',
    parentBreadcrumb: [
      {
        label: 'Projects',
        href: (_params, orgSlug) => `/${orgSlug}/deployments/projects`
      },
      {
        label: (params) =>
          (params as { projectId?: string }).projectId ?? 'Project',
        href: (params, orgSlug) =>
          `/${orgSlug}/deployments/projects/${(params as { projectId?: string }).projectId ?? ''}`
      }
    ]
  }
}
